import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Ensures user is on the right onboarding step based on backend check.
// desired: 'signature' | 'payment' | 'client'
export default function OnboardingGuard({ desired = 'client', children }) {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    let canceled = false;

    async function check() {
      try {
        const { fetchAuthSession } = await import('aws-amplify/auth');
        const session = await fetchAuthSession();
        const idToken = session?.tokens?.idToken?.toString?.();
        if (!idToken) {
          if (!canceled) setLoading(false);
          return;
        }

        const res = await fetch(`${process.env.REACT_APP_API_URL}/completed-signup-check`, {
          headers: { Authorization: `Bearer ${idToken}` },
        });
        const data = await res.json().catch(() => ({}));
        const target = data?.step === 'signature' ? '/signature' : data?.step === 'payment' ? '/payment' : '/client';

        const needRedirect =
          (desired === 'signature' && target !== '/signature') ||
          (desired === 'payment' && target !== '/payment') ||
          (desired === 'client' && target !== '/client');

        if (!canceled) {
          if (needRedirect) navigate(target, { replace: true });
          setLoading(false);
        }
      } catch (_) {
        if (!canceled) setLoading(false);
      }
    }

    check();
    return () => { canceled = true; };
  }, [desired, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-orange-500 mx-auto mb-4" />
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return children;
}

